var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessful(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "876 3033 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #3db39e;\n      }\n\n      .cls-2 {\n        fill: #37a18e;\n      }\n\n      .cls-3 {\n        fill: #f2f1ef;\n      }\n\n      .cls-4 {\n        fill: #e6e5e3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checked",
    transform: "translate(876 3033)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    className: "cls-1",
    cx: 50,
    cy: 50,
    r: 50,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    className: "cls-2",
    d: "M284.465,114.609l-44.219,45.782.078,4.922h2.031l47.891-38.594A50.847,50.847,0,0,0,284.465,114.609Z",
    transform: "translate(-192.589 -91.875)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    className: "cls-3",
    d: "M174.757,64.669l-8.828-8.75a3.161,3.161,0,0,0-4.375,0L123.819,94.9,107.491,78.81a3.161,3.161,0,0,0-4.375,0L95.3,86.544a3.065,3.065,0,0,0,0,4.3L121.4,116.7a4.3,4.3,0,0,0,5.156,0l48.2-47.657A3.161,3.161,0,0,0,174.757,64.669Z",
    transform: "translate(-75.694 -44.122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    className: "cls-4",
    d: "M126.869,150.562l48.2-47.657a3.065,3.065,0,0,0,0-4.3l-1.406-1.328-49.454,48.594L96.869,119.233,95.7,120.405a3.065,3.065,0,0,0,0,4.3l26.094,25.86a3.172,3.172,0,0,0,2.578.859A3.1,3.1,0,0,0,126.869,150.562Z",
    transform: "translate(-76.009 -77.983)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessful);
export default __webpack_public_path__ + "static/media/successful.2cf789766e3408b4f12686b654fea23c.svg";
export { ForwardRef as ReactComponent };